import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import styles from "./RouteOneEpaAccordion.module.scss";

export const ROUTE_ONE_EPA_URL =
  "https://www.routeone.net/Web/BIServlet?captiveId=ROUTEONE&agreementID=1e240ddd7f3718f0ba045e9ec63fecf3";

const RouteOneEpaAccordion = () => {
  const { t } = useTranslation();

  return (
    <Box className={styles.container} data-testid="route-one-epa-accordion">
      <Typography variant="body1" className={styles.copy}>
        {t(
          "DealerOnboarding.content.financing.routeOneEpa.copyFirstParagraphBeforeSignEpa",
          "To activate the Digitally Supported Selling System for your dealership, you must accept RouteOne’s Electronic Participation Agreement (ePA). Select "
        )}
        <strong>
          {t(
            "DealerOnboarding.content.financing.routeOneEpa.signEpaInlineText",
            "Sign ePA"
          )}
        </strong>
        {t(
          "DealerOnboarding.content.financing.routeOneEpa.copyFirstParagraphAfterSignEpa",
          " to be directed to RouteOne and complete this step."
        )}
        <br />
        <br />
        {t(
          "DealerOnboarding.content.financing.routeOneEpa.copySecondParagraph",
          "Once the ePA has been accepted in RouteOne, all remaining F&I setup steps can be completed on their site. You can visit RouteOne to access your setup details."
        )}
      </Typography>

      <a
        href={ROUTE_ONE_EPA_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.signButton}
        data-testid="route-one-epa-sign-button"
      >
        <span>
          {t(
            "DealerOnboarding.content.financing.routeOneEpa.signButton",
            "Sign ePA"
          )}
        </span>
        <span className={styles.signButtonIcon} aria-hidden="true">
          ›
        </span>
      </a>
    </Box>
  );
};

export default RouteOneEpaAccordion;
